document.addEventListener("DOMContentLoaded", () => {
    const email = "hotheadseedco@gmail.com";

    const descriptions = document.querySelectorAll(
        ".product-details .text-block"
    );

    descriptions.forEach(description => {
        const walker = document.createTreeWalker(
            description,
            NodeFilter.SHOW_TEXT
        );

        const nodes = [];

        while (walker.nextNode()) {
            nodes.push(walker.currentNode);
        }

        nodes.forEach(node => {
            if (node.parentElement.closest("a, script, style")) return;
            if (!node.textContent.includes(email)) return;

            const parts = node.textContent.split(email);
            const fragment = document.createDocumentFragment();

            parts.forEach((part, index) => {
                fragment.append(document.createTextNode(part));

                if (index < parts.length - 1) {
                    const link = document.createElement("a");

                    link.href = `mailto:${email}`;
                    link.textContent = email;

                    fragment.append(link);
                }
            });

            node.replaceWith(fragment);
        });
    });
});